import { render, staticRenderFns } from "./_ProductInfoBlock.vue?vue&type=template&id=1f47a0d4"
import script from "./_ProductInfoBlock.vue?vue&type=script&lang=js"
export * from "./_ProductInfoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports